import { z } from 'zod';

export const OfferConfirmedEventPayloadSchema = z
  .object({
    offerId: z.number().int().positive(),
    campaignNumber: z.string().min(1),
    status: z.literal('CONFIRMED'),
    confirmedBy: z.number().int().positive(),
    confirmedAt: z.string().datetime(),
  })
  .strict();

export type OfferConfirmedEventPayload = z.infer<typeof OfferConfirmedEventPayloadSchema>;
